import apiManutencao from '../../services/apis/apiManutencao';

const MENSAGENS_ERRO = {
    concluir: 'Erro ao concluir tarefa',
    reagendar: 'Erro ao reagendar tarefa',
    ignorar: 'Erro ao ignorar tarefa',
    reabrir: 'Erro ao reabrir tarefa',
};

export const mensagemErroAcao = (acao) => MENSAGENS_ERRO[acao] ?? 'Erro ao atualizar tarefa';

export const executarAcaoTarefa = (id, acao, { executadoPor, observacao, novaData } = {}) => {
    switch (acao) {
        case 'concluir':
            return apiManutencao.concluirTarefa(id, executadoPor, observacao);
        case 'reagendar':
            return apiManutencao.reagendarTarefa(id, executadoPor, observacao, novaData);
        case 'ignorar':
            return apiManutencao.ignorarTarefa(id, executadoPor, observacao);
        default:
            return apiManutencao.reabrirTarefa(id);
    }
};
